<template>
  <div class="investMatrix">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="-1"
      item-key="ExitType"
      @click:row="onRowClick"
      dense
    >
      <template v-slot:top>
        <div class="tableToolbar">
          <v-dialog persistent v-model="isDialogShown" max-width="750">
            <v-card v-if="editedItem">
              <v-card-title>
                <span class="text-h5">Edit {{ editedItem.ExitType }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col v-for="key in itemKeys" :key="key" cols="4" sm="4" md="4">
                      <v-select
                        v-model="editedItem[key]"
                        :items="actionList"
                        :label="key"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="onCancel"> Cancel </v-btn>
                <v-btn color="primary" depressed @click="onOk"> Ok </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-data-table>
    <v-footer
      v-if="showFormButtons"
      padless
      fixed
      outlined
      class="pl-5 pr-5 pt-3 pb-3 footerBtnContainer"
      color="white"
      elevation="3"
    >
      <v-spacer></v-spacer>
      <div class="btnsContainer">
        <v-btn color="primary" @click="onSave" depressed>Save</v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
import Utils from '@/utils.js';

export default {
  name: 'InvestMatrix',
  data() {
    return {
      loading: false,
      headers: [],
      items: [],
      investMatrix: [],
      isDialogShown: false,
      selectedItem: null,
      editedItem: null,
      itemKeys: [],
      actionList: ['', 'Sell', 'Retain', 'Hold'],
    };
  },
  created() {
    this.getMatrix();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  mounted() {
    this.$root.currentPage = 'Investment';
  },
  destroyed() {
    this.$root.currentPage = null;
  },
  methods: {
    onRowClick(item) {
      if (!this.showFormButtons) return;
      this.selectedItem = item;
      this.editedItem = { ...item };
      this.isDialogShown = true;
    },
    onCancel() {
      this.editedItem = null;
      this.selectedItem = null;
      this.isDialogShown = false;
    },
    onOk() {
      Object.keys(this.selectedItem).forEach((key) => {
        this.selectedItem[key] = this.editedItem[key];
      });
      this.onCancel();
    },
    onSave() {
      this.processInvestMatrix();
      this.updateInvestMatrix();
    },

    async getMatrix() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          '/invest/GetInvestmentMatrix?planId=' + this.currentPlanId
        );

        this.investMatrix = response.data;
        this.processTable();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
    async updateInvestMatrix() {
      console.log(this.items);
      this.loading = true;
      try {
        const model = {
          PlanId: this.currentPlanId,
          Cells: this.investMatrix,
        };

        await this.$api.post('/invest/UpdateInvestmentMatrix', model);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Saved!',
        });
        this.getMatrix();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
    processTable() {
      if (this.investMatrix && this.investMatrix.length > 0) {
        const items = [];
        this.itemKeys = [];
        const headers = [{ text: '', value: 'StatusGroup' }];
        const matrixItems = [];
        if (this.investMatrix) {
          this.investMatrix.forEach((x) => {
            x.forEach((y) => {
              if (y.StatusGroup) matrixItems.push(y);
            });
          });
        }
        const groups = Utils.groupBy(matrixItems, 'ContributionType');
        Object.keys(groups).forEach((key) => {
          headers.push({ text: key, value: key });
          this.itemKeys.push(key);
          const groupsItems = groups[key];
          if (groupsItems) {
            groupsItems.forEach((groupItem) => {
              const existItem = items.find((x) => {
                return x.StatusGroup == groupItem.StatusGroup;
              });
              if (existItem) {
                existItem[key] = groupItem.Instruction;
              } else {
                const newResultItem = {
                  StatusGroup: groupItem.StatusGroup,
                };
                newResultItem[key] = groupItem.Instruction;
                items.push(newResultItem);
              }
            });
          }
        });

        this.headers = headers;
        this.items = items;
      }
    },
    processInvestMatrix() {
      if (this.investMatrix && this.investMatrix.length > 0) {
        if (this.investMatrix) {
          this.investMatrix.forEach((x) => {
            x.forEach((y) => {
              if (y.StatusGroup) {
                const item = this.items.find((i) => {
                  return i.StatusGroup == y.StatusGroup;
                });
                if (item) {
                  y.Instruction = item[y.ContributionType];
                }
              }
            });
          });
        }
      }
    },
  },
};
</script>

<style>
.investMatrix {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
/* 
.footerBtnContainer {
  background: white;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0px -4px 5px 0px #00000040;
} */

.v-footer {
  padding: 0px;
}
</style>
